import { numberWithCommas } from 'src/helper/numberWithCommas';

/**
 * Converts a long string into smaller chunks (as array).
 * This is needed so that the waterfall model shows no diagonal text.
 */
export function waterfallLabelSeparation(i, count, dataLabels, t) {
  const label = t('Statistics.Status.Waterfall.Label', {
    ordinal: i < 2 ? '' : `${i - 1}. `,
    label: t(`OrgUnitStatus.${dataLabels[i]}`),
  });
  const final = label.match(/.{1,14}(\s|$)/g);
  const a = [...final, `= ${numberWithCommas(count)}`];
  return a;
}
